export const MATERIAL_SECTIONS = [
  {
    id: "02",
    title: "Basic Materials",
    fields: [
      { key: "cement", label: "Cement", placeholder: "Qty", unit: { type: "fixed", value: "Bag" } },
      { key: "steel", label: "Steel (Sariya)", placeholder: "Qty", unit: { type: "select", options: ["Kg", "Quintal"] } },
      { key: "bricks", label: "Bricks", placeholder: "Qty", unit: { type: "select", options: ["Pcs", "Truck", "Trolley"] } },
      { key: "red_sand", label: "Red Sand", placeholder: "Qty", unit: { type: "select", options: ["CFT", "Truck", "Trolley"] } },
      { key: "white_sand", label: "White Sand", placeholder: "Qty", unit: { type: "select", options: ["CFT", "Truck", "Trolley"] } },
      { key: "aggregate_bajri", label: "Aggregate / Bajri", placeholder: "Qty", unit: { type: "select", options: ["CFT", "Truck", "Trolley"] } },
      { key: "pavna_gravel", label: "Pavna / Gravel", placeholder: "Qty", unit: { type: "select", options: ["CFT", "Truck", "Trolley"] } },
    ],
  },
  {
    id: "03",
    title: "Masonry & Concrete Works",
    fields: [
      { key: "red_blocks", label: "Red Blocks", placeholder: "Qty", unit: { type: "select", options: ["Pcs", "Truck"] } },
      { key: "red_blocks_aggregate", label: "Red Blocks Aggregate", placeholder: "Qty", unit: { type: "select", options: ["CFT", "Truck"] } },
      { key: "fly_ash_bricks", label: "Fly Ash Bricks", placeholder: "Qty", unit: { type: "select", options: ["Pcs", "Truck"] } },
      {
        key: "wood_timber",
        label: "Wood / Timber (Frames & Shuttering)",
        placeholder: "Qty",
        extra: { key: "wood_timber_size", placeholder: "Size / Dimensions" },
        unit: { type: "select", options: ["Pcs"] },
      },
    ],
  },
  {
    id: "04",
    title: "Plumbing Materials",
    fields: [
      { key: "submersible_boring", label: "Submersible Boring", placeholder: "Depth", unit: { type: "fixed", value: "RFT" } },
      { key: "pvc_pipes", label: "PVC Pipes", placeholder: "Length", unit: { type: "fixed", value: "RFT" } },
      { key: "cpvc_pipes", label: "CPVC Pipes", placeholder: "Length", unit: { type: "fixed", value: "RFT" } },
      { key: "taps_faucets", label: "Taps / Faucets", placeholder: "Qty", unit: { type: "fixed", value: "Pcs" } },
      { key: "water_tank", label: "Water Tank", placeholder: "Capacity", unit: { type: "fixed", value: "Ltr" } },
      { key: "wash_basin", label: "Wash Basin", placeholder: "Qty", unit: { type: "fixed", value: "Pcs" } },
      { key: "shower", label: "Shower", placeholder: "Qty", unit: { type: "fixed", value: "Pcs" } },
      { key: "sewage_pipes", label: "Sewage Pipes", placeholder: "Length", unit: { type: "fixed", value: "RFT" } },
    ],
  },
  {
    id: "05",
    title: "Electrical Materials",
    fields: [
      { key: "electrical_wires_cables", label: "Electrical Wires / Cables", placeholder: "Qty", unit: { type: "fixed", value: "Bundle" } },
      { key: "conduit_pipes", label: "Conduit Pipes", placeholder: "Qty", unit: { type: "select", options: ["Pcs", "Bundle"] } },
      { key: "switchboards_sockets", label: "Switchboards / Sockets", placeholder: "Qty", unit: { type: "fixed", value: "Pcs" } },
      { key: "mcb_breakers", label: "MCB / Breakers", placeholder: "Qty", unit: { type: "fixed", value: "Pcs" } },
      { key: "distribution_box", label: "Distribution Box", placeholder: "Qty", unit: { type: "fixed", value: "Pcs" } },
      { key: "lights_fans", label: "Lights & Fans", placeholder: "Qty", unit: { type: "fixed", value: "Pcs" } },
    ],
  },
  {
    id: "06",
    title: "Doors & Windows",
    fields: [
      { key: "door_frames", label: "Door Frames", placeholder: "Qty", unit: { type: "fixed", value: "Pcs" } },
      { key: "door_panels", label: "Door Panels", placeholder: "Qty", unit: { type: "fixed", value: "Pcs" } },
      { key: "windows", label: "Windows", placeholder: "Qty", unit: { type: "fixed", value: "Pcs" } },
      { key: "glass", label: "Glass", placeholder: "Qty", unit: { type: "fixed", value: "Sqft" } },
      { key: "locking_systems", label: "Locking Systems", placeholder: "Qty", unit: { type: "fixed", value: "Pcs" } },
      { key: "hinges_handles", label: "Hinges & Handles", placeholder: "Qty", unit: { type: "fixed", value: "Pcs" } },
    ],
  },
  {
    id: "07",
    title: "Finishing Materials",
    fields: [
      { key: "flooring_tiles", label: "Flooring Tiles", placeholder: "Area", unit: { type: "fixed", value: "Sqft" } },
      { key: "marble_granite", label: "Marble / Granite", placeholder: "Area", unit: { type: "fixed", value: "Sqft" } },
      { key: "wall_putty", label: "Wall Putty", placeholder: "Qty", unit: { type: "select", options: ["Bag", "Kg"] } },
      { key: "primer", label: "Primer", placeholder: "Volume", unit: { type: "fixed", value: "Ltr" } },
      { key: "paints", label: "Paints", placeholder: "Volume", unit: { type: "fixed", value: "Ltr" } },
      { key: "waterproofing", label: "Waterproofing", placeholder: "Volume", unit: { type: "fixed", value: "Ltr" } },
      { key: "staircase_railing", label: "Staircase Railing", placeholder: "Length", unit: { type: "fixed", value: "RFT" } },
      { key: "main_gate", label: "Main Gate", placeholder: "Weight", unit: { type: "fixed", value: "Kg" } },
    ],
  },
  {
    id: "08",
    title: "False Ceiling",
    fields: [
      { key: "minus_plus_pop", label: "Minus-Plus POP Design", placeholder: "Area", unit: { type: "fixed", value: "Sqft" } },
      { key: "gypsum_board_ceiling", label: "Gypsum Board Ceiling", placeholder: "Area", unit: { type: "fixed", value: "Sqft" } },
      { key: "grid_ceiling", label: "Grid Ceiling", placeholder: "Area", unit: { type: "fixed", value: "Sqft" } },
      { key: "wooden_pvc_panelling", label: "Wooden / PVC Panelling", placeholder: "Area", unit: { type: "fixed", value: "Sqft" } },
    ],
  },
  {
    id: "09",
    title: "Modular Kitchen",
    fields: [
      { key: "base_wall_cabinets", label: "Base & Wall Cabinets", placeholder: "Qty", unit: { type: "select", options: ["Rft", "Sqft"] } },
      { key: "countertop", label: "Countertop (Granite / Marble / Quartz)", placeholder: "Qty", unit: { type: "select", options: ["Rft", "Sqft"] } },
      { key: "baskets_hardware", label: "Baskets & Hardware (Accessories)", placeholder: "Qty", unit: { type: "fixed", value: "Pcs" } },
      { key: "chimney_hob", label: "Chimney & Hob (Appliances)", placeholder: "Amount", unit: { type: "fixed", value: "Lump Sum" } },
    ],
  },
  {
    id: "10",
    title: "TV Panel & Living Room",
    fields: [
      { key: "tv_unit", label: "TV Unit (TV Panel)", placeholder: "Area", unit: { type: "fixed", value: "Sqft" } },
      { key: "sofa_lounger", label: "Sofa & Lounger", placeholder: "Qty", unit: { type: "fixed", value: "Per Seat" } },
      { key: "shoe_rack", label: "Shoe Rack", placeholder: "Qty", unit: { type: "select", options: ["Sqft", "Rft"] } },
    ],
  },
  {
    id: "11",
    title: "Wardrobe & Bedroom",
    fields: [
      { key: "wardrobe", label: "Wardrobe (Almirah)", placeholder: "Area", unit: { type: "fixed", value: "Sqft" } },
      { key: "bed", label: "Bed", placeholder: "Size e.g. 6x6 ft", inputType: "text", unit: { type: "select", options: ["Fixed Size", "Sqft"] } },
      { key: "dressing_table", label: "Dressing Table", placeholder: "Area", unit: { type: "fixed", value: "Sqft" } },
      { key: "side_tables", label: "Side Tables", placeholder: "Qty", unit: { type: "fixed", value: "Pcs" } },
    ],
  },
];

export const WORK_TYPES = ["Residential", "Commercial", "Renovation", "Industrial"];

export const buildInitialSectionValues = () => {
  const values = {};
  MATERIAL_SECTIONS.forEach((section) => {
    const sectionValues = { remark: "" };
    section.fields.forEach((field) => {
      sectionValues[field.key] = "";
      if (field.unit?.type === "select") {
        sectionValues[`${field.key}_unit`] = field.unit.options[0];
      }
      if (field.extra) {
        sectionValues[field.extra.key] = "";
      }
    });
    values[section.id] = sectionValues;
  });
  return values;
};
